
import { computed, defineComponent, PropType } from "vue";
import { Diamond } from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import { useI18n } from "vue-i18n";
import useDiamondShapeImageMap from "@/composables/useDiamondShapeImageMap";

export default defineComponent({
    name: "ComparableDiamondCard",
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        },
        heading: {
            type: String,
            required: true
        },
        highlightAttribute: {
            type: String,
            required: false,
            default: null
        }
    },
    setup(props) {
        const {
            cut,
            shape,
            carat,
            clarity,
            color,
            priceHumanReadable,
            productId
        } = useDiamondProperties(computed(() => props.diamond));

        const diamondShapeImageMap = useDiamondShapeImageMap();
        const image = computed(() => diamondShapeImageMap[props.diamond.shape]);

        return {
            ...useI18n(),
            cut,
            shape,
            carat,
            clarity,
            color,
            priceHumanReadable,
            productId,
            image
        };
    }
});
